import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Card, Divider, Form, Select, Space } from 'antd';
import { DeleteOutlined, NodeExpandOutlined, PlusOutlined } from '@ant-design/icons';
import { calculCondition, CONDITIONS } from './index';
import ReactDOM from 'react-dom';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const CONDITIONS_ACTIONS = [
    `Masquer`,
    `Afficher`
]

export default (formPlugin, namespace) =>
{

    const FormComponent = (props) => {

        const { data } = props

        const [show, setShow] = useState(true)
        const refreshForm = () => {
            setShow(false)
            setTimeout(() => setShow(true), 100)
        }

        useEffect(() => {
            refreshForm()
        }, [props.lang, props.nodeId, props.device])

        const formFields = formPlugin.getFormFields(props.pluginConfig.namespace)

        if (!show) {
            return null
        }

        return (
            <Form
                layout="vertical"
                initialValues={data}
                onValuesChange={(_, allValues) => {
                    props.onChange(allValues)
                }}
            >

                <Form.Item name={"default"} label={<Trans>Par Défaut</Trans>}>
                    <Select>
                        {CONDITIONS_ACTIONS.map(i => <Select.Option key={i} value={i}>{i}</Select.Option>)}
                    </Select>
                </Form.Item>

                <Divider><Trans>Conditions</Trans></Divider>
                <div style={{ marginBottom: 20 }}>
                    <Form.List name="conditions">
                        {(fields, { add, remove }) => (
                            <div style={{ width: 310 }}>
                                {fields.map((field, index) => {
                                    return (
                                        <Card
                                            title={<Trans>Condition {index + 1}</Trans>}
                                            type="inner"
                                            key={field.key}
                                            extra={(<DeleteOutlined onClick={() => remove(field.name)} />)}
                                        >
                                            <Space direction={"vertical"} style={{ width: "100%" }}>
                                                <Form.Item required label={<Trans>Champ</Trans>} name={[field.name, "field"]}>
                                                    <Select>
                                                        {formFields.map(i =>
                                                            <Select.Option key={i} value={i}>{i}</Select.Option>
                                                        )}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item required label={<Trans>Condition</Trans>} name={[field.name, "type"]}
                                                           style={{ width: "100%" }}>
                                                    <Select style={{ width: "100%" }}>
                                                        {CONDITIONS.map(i =>
                                                            <Select.Option key={i} value={i}>{i}</Select.Option>
                                                        )}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item label={<Trans>Valeurs</Trans>} name={[field.name, "values"]}
                                                           style={{ width: "100%" }}>
                                                    <Select style={{ width: "100%" }} mode={"tags"} />
                                                </Form.Item>
                                            </Space>

                                            <Divider dashed style={{ margin: "0 10px" }}>
                                                <Form.Item name={[field.name, "next"]}>
                                                    <Select placeholder={t`ET`} style={{ width: 75 }}>
                                                        <Select.Option value={"AND"}><Trans>ET</Trans></Select.Option>
                                                        <Select.Option value={"OR"}><Trans>OU</Trans></Select.Option>
                                                    </Select>
                                                </Form.Item>
                                            </Divider>
                                        </Card>
                                    )
                                })}
                                <Button style={{ marginTop: 20 }} type="dashed" onClick={() => add()} block
                                        icon={<PlusOutlined />}>
                                    <Trans>Ajouter une condition</Trans>
                                </Button>
                            </div>
                        )}
                    </Form.List>
                </div>

                <Form.Item name={"action"} label={<Trans>Si Match, alors :</Trans>}>
                    <Select>
                        {CONDITIONS_ACTIONS.map(i => <Select.Option key={i} value={i}>{i}</Select.Option>)}
                    </Select>
                </Form.Item>
            </Form>
        )
    }

    return {
        Renderer: (props) => {
            const { data } = props

            let containerRef = useRef(null)
            const [listField, setlistField] = useState(null)
            useEffect(() => {
                if (!listField) {
                    // setlistField(props.pluginConfig.getListField(containerRef.current))
                }
            }, [containerRef.current])

            const liveRender = (props.isPreviewMode || formPlugin.live)

            const getDisplayFromAction = (action) => {
                switch (action) {
                    case CONDITIONS_ACTIONS[0]:
                        return false
                    case CONDITIONS_ACTIONS[1]:
                        return true
                }
            }

            const renderAlerts = () => {
                const formFields = formPlugin.getFormFields(props.pluginConfig.namespace)
                const conditionsFields = data.conditions.filter(i => i?.field).map(i => i.field)
                const unFindFields = conditionsFields.filter(i => !formFields.includes(i))

                return (
                    <Space direction={"vertical"} style={{ margin: "20px 0" }}>
                        {unFindFields.map(i => (
                            <Alert
                                key={i}
                                showIcon
                                type={"warning"}
                                message={t`Le champ "${i}" n'existe pas.`}
                                description={t`Il se peut que vous avez changé l'étiquette du champ, n'oubliez pas de modifier votre condition en conséquence !`}
                            />
                        ))}
                    </Space>
                )
            }

            const cnamespace = props.pluginConfig.namespace.replaceAll("/", "")
            var finalAction = calculCondition(formPlugin.formValues, data.default, data.conditions, data.action, cnamespace, listField)
            var display = getDisplayFromAction(finalAction)

            if (!display && liveRender) {
                return (
                    <div ref={(ref) => containerRef.current = ref} />
                )
            }

            return (
                <div ref={(ref) => containerRef.current = ref}>
                    <div style={{
                        border: liveRender ? "none" : "1px dashed orange",
                        borderRadius: liveRender ? 0 : 10,
                        padding: liveRender ? 0 : "2%"
                    }}>
                        {!liveRender && renderAlerts()}
                        {props.children}
                    </div>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-condition' + namespace,
        title: t`Condition`,
        description: t`Élément de formulaire utilisable.`,
        icon: <NodeExpandOutlined />,
        iconColor: "#2980B9",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) {
                return JSON.parse(listField)
            }
            return null
        },
        createInitialData: () => {
            return { default: CONDITIONS_ACTIONS[0], conditions: [], action: CONDITIONS_ACTIONS[1] }
        },
        controls: {
            type: 'custom',
            Component: FormComponent
        },
    }
}
